export type ResolveVoidSaleBranchIdResult =
  | { ok: true; branchId: string }
  | { ok: false; message: string };

/** Fuente de verdad para anular: la sucursal de la venta debe coincidir con la activa. */
export function resolveVoidSaleBranchId(params: {
  activeBranchId: string | null | undefined;
  saleBranchId: string | null | undefined;
}): ResolveVoidSaleBranchIdResult {
  const saleBranchId = params.saleBranchId?.trim() || null;
  const activeBranchId = params.activeBranchId?.trim() || null;

  if (!saleBranchId) {
    return {
      ok: false,
      message: 'No cargó el detalle. Refrescá e intentá de nuevo.',
    };
  }

  if (!activeBranchId) {
    return {
      ok: false,
      message: 'Elegí una sucursal e intentá de nuevo.',
    };
  }

  if (saleBranchId !== activeBranchId) {
    return {
      ok: false,
      message: 'Esta venta es de otra sucursal. Volvé al listado.',
    };
  }

  return { ok: true, branchId: saleBranchId };
}
